import { useState } from "react";
import { AdminEmployeesTab } from "../components/admin/AdminEmployeesTab";
import { AdminBookingsTab } from "../components/admin/AdminBookingsTab";
import { AdminDayOverridesTab } from "../components/admin/AdminDayOverridesTab";

type AdminTab = "employees" | "bookings" | "days";

const TABS: { id: AdminTab; label: string }[] = [
  { id: "employees", label: "Employees" },
  { id: "bookings", label: "Bookings" },
  { id: "days", label: "Schedule overrides" },
];

export function AdminPage() {
  const [tab, setTab] = useState<AdminTab>("employees");

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Admin</h1>
          <p className="page-sub">Manage employees, bookings, and the gym schedule.</p>
        </div>
      </header>

      <div className="admin-tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={tab === t.id ? "admin-tab-btn is-active" : "admin-tab-btn"}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "employees" && <AdminEmployeesTab />}
      {tab === "bookings" && <AdminBookingsTab />}
      {tab === "days" && <AdminDayOverridesTab />}
    </div>
  );
}
